import { useMemo } from 'react';

/**
 * Determines whether a component is active or expired based on the provided expiry date.
 * @param expiryDate - date string representing the expiration date (e.g., "2024-12-31T23:59:59Z")
 * @returns boolean - Returns true if the component is expired (current date > expiry date), false otherwise
 */
const useComponentExpiry = expiryDate => useMemo(() => {
  const inputDate = Date.parse(expiryDate);
  if (isNaN(inputDate)) {
    // Invalid date - component is considered expired
    return true;
  }

  // Compare input date with current time
  const currentTime = Date.now();
  return currentTime > inputDate;
}, [expiryDate]);

export { useComponentExpiry as u };
//# sourceMappingURL=useComponentExpiry-BuxM8zWv.js.map
